const config = {
    apiKey: "AIzaSyDlAp3fyy6RnE39OoYbUzHtjvgyv7CEGjg",
    authDomain: "my-notes-2964d.firebaseapp.com",
    projectId: "my-notes-2964d",
    storageBucket: "my-notes-2964d.appspot.com",
    messagingSenderId: "684231297125",
    appId: "1:684231297125:web:b2ff1bc6057f6471391e8c",
    measurementId: "G-N72GKW3VNM",
  };
  
  export { config };